// extracted by mini-css-extract-plugin
module.exports = {"group":"RequestDetails_group__3V1uk","group-item":"RequestDetails_group-item__3QBWN"};